import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { SimpleRouterState } from '@platform-frontend/util';
import { Observable, of, switchMap } from 'rxjs';
import { AccountRouteService } from '../account-router';
import { AccountStartupService } from '../account-startup';
import { AuthFormState } from '../auth-form';
import { LinkAccountState } from '../link-account/link-account.state';
import { SignInMode } from '../session';
import { EmailAuthenticationService } from './email-authentication.service';

export const EmailAuthenticationStartupGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const emailAuthenticationService = inject(EmailAuthenticationService);
  const accountStartupService = inject(AccountStartupService);
  const accountRouteService = inject(AccountRouteService);

  if (store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    const signInModeParam: string = route.queryParamMap.get('signInMode') ?? 'MANUAL';
    const redirectUrl: string | null = accountRouteService.getRedirectUrl(route.paramMap) ?? null;
    const signInMode: SignInMode = (signInModeParam === '' ? 'MANUAL' : signInModeParam) as SignInMode;

    accountStartupService
      .getStartupObservable(route.paramMap, { signInMode }, () => autoStartAuthenticationIfAllowed(signInMode, redirectUrl, store, emailAuthenticationService))
      .subscribe();
  }

  return true;
};

const autoStartAuthenticationIfAllowed = (
  signInMode: SignInMode,
  redirectUrl: string | null,
  store: Store,
  emailAuthenticationService: EmailAuthenticationService
): Observable<unknown> =>
  signInMode === 'AUTO' && store.selectSnapshot(LinkAccountState.accountIdLinked)
    ? store
        .selectOnce(AuthFormState.email)
        .pipe(switchMap(email => emailAuthenticationService.checkEmailAndReturnInputRequired(email, true, redirectUrl ?? undefined)))
    : of(null);
